module.exports = __webpack_public_path__ + "img/check.b51fe969.png";